import { Box } from "@mui/material";
import { DotLegalAlert, DotLegalButton, DotLegalDatePicker, DotLegalDialog, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { getDriftWarningText } from "../riskDriftWarning";
import { useAcceptRiskDialog } from "./AcceptRiskDialog.hooks";
import { TreatmentDialogProps } from "./TreatmentDialogs.types";
import { useTreatmentDialogStyles } from "./TreatmentDialogs.styles";

function AcceptRiskDialog(props: TreatmentDialogProps) {
    const { translateString, translateDate, getDateTimePickerLanguage } = useTranslation();
    const styles = useTreatmentDialogStyles();
    const { showDriftBanner, canReconfirm, isAlreadyAccepted, reconfirm, reason, setReason, reviewBy, setReviewBy, okButtonDisabled, onSave, inProgress } =
        useAcceptRiskDialog(props);

    const driftWarningText = getDriftWarningText(props.scenario, translateString, translateDate);

    return (
        <DotLegalDialog
            open
            header={translateString("riskMitigationActionAcceptRisk")}
            buttonOkText={translateString("save")}
            onDialogClose={props.onClose}
            onOkClick={onSave}
            okButtonDisabled={okButtonDisabled}
            inProgress={inProgress}
            size={"sm"}
        >
            <Box sx={styles.content}>
                <Box sx={styles.subHeader}>
                    <DotLegalHeader center marginTop={-1} marginBottom={0} fontWeight={400} headerStyle="small">
                        {translateString("riskTreatmentAcceptDescription")}
                    </DotLegalHeader>
                </Box>
                {isAlreadyAccepted && <DotLegalAlert warningText={translateString("riskTreatmentAlreadyAccepted")} severity={"info"} />}

                {showDriftBanner && (
                    <DotLegalAlert
                        warningText={driftWarningText}
                        severity={"info"}
                        action={
                            canReconfirm ? (
                                <DotLegalButton buttonType="secondary" size="small" onClick={reconfirm}>
                                    {translateString("reconfirm")}
                                </DotLegalButton>
                            ) : undefined
                        }
                    />
                )}

                <Box sx={styles.sectionContent}>
                    <DotLegalTextField
                        label={translateString("justification")}
                        value={reason}
                        onChange={setReason}
                        multiline
                        rows={3}
                        noMargin
                        debounce={false}
                    />
                    <DotLegalDatePicker
                        label={translateString("riskMitigationAcceptReviewBy")}
                        value={reviewBy}
                        onChange={setReviewBy}
                        language={getDateTimePickerLanguage()}
                        noMargin
                    />
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default AcceptRiskDialog;
